module.exports = __webpack_public_path__ + "static/media/azntraitsmag.b2ca9a0b.png";